import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserdataService } from '../services/userdata.service';
import { Router, Event, NavigationEnd } from '@angular/router';
import { WindowRefService, ICustomWindow } from '../services/window.service';
import * as LogRocket from 'logrocket';
declare var tribed:any;

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

	@Input() page: string;
  @Output() nextClicked = new EventEmitter<string>();
	user: any;
  userData: any;
  fullWidth: boolean = true;
  atTopOfPage: boolean = true;
  private _window: ICustomWindow;

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
  //In chrome and some browser scroll is given to body tag
    let pos = document.documentElement.scrollTop || document.body.scrollTop
    
    if(pos > 0 )   {
      // user is at top of page
      this.atTopOfPage = false
    } else {
      this.atTopOfPage = true
}
  }

  constructor(
    windowRef: WindowRefService,
  	private authService: AuthService,
  	private userDataService: UserdataService,
  	private router: Router
  ) {
    
    // get reference to window
    this._window = windowRef.nativeWindow

    router.events.subscribe( (event: Event) => {
      
        if (event instanceof NavigationEnd) {
            // Hide loading indicator
            console.log('router event:', event);
            if(event.url.indexOf('/build')>=0){
              // make the nav small
              this.fullWidth = false
            } else {
              // make the nav full width
              this.fullWidth = true
            }
        }

    });

  }

  ngOnInit() {
    
  	// console.log("page is: ", this.page);

  	// get currently authed user
    this.authService.getAuthState()
      .subscribe((user) => {

        this.user = user

        console.log('USER:', user);

        
        // if we have a user, show avatar and say hi
        if(this.user){
          
          LogRocket.identify(user.uid, {
            name: user.displayName,
            email: user.email
          });
          
          this.userDataService.getData()
            .subscribe(data => {
              this.userData = data;
              console.log('nav userData:', this.userData);
            })
        	
        } else {
        	// show sign in button
        }
      });
  }

  public nextButtonClicked(){

    this.nextClicked.emit();

  }

  public loginWithGithub() {
    this.authService.loginWithGithub()
      .then(data => {
        console.log("login w/Github:", data);

        // track in SA
        if(this._window.sa_event){
          this._window.sa_event('login-with-'+data.credential.providerId);
        }

        tribed("trait", "user_id", data.user.uid);
        tribed("trait", "email", data.user.email);
        tribed("trait", "name", data.user.displayName);
        tribed("trait", "avatar", data.user.photoURL);

        LogRocket.identify(data.user.uid, {
          name: data.user.displayName,
          email: data.user.email
        });

        // save the data (will save to FB via userDataService)
        this.userDataService.saveUserLoginData(data);

        // if user is new, send em to builder and handhold
        if(data.additionalUserInfo.isNewUser){
          // navigate to build with query param
          this.router.navigate(['/build'], {queryParams: {"newb": "y"} });
          tribed("event", "sign-up");
        } else {
          // navigate to build without query param
          this.router.navigate(['/build'], {queryParams: {} });
          tribed("event", "log-in");
        }

      })
      .catch(error => {
        console.log('error:', error)
        alert('something went wrong signing in: ' + error);
      })
  }

  public logout(){
	  this.authService.logout().then( data => {
	  	console.log('user logged out:', data);
      this.router.navigate(['/'])
	  })
	 	.catch( err => {
	 		console.log('error logging user out:', err);
      alert("something went wrong logging you out :( error:"+err);
	 	})
	}

}



// WEBPACK FOOTER //
// ./src/app/nav/nav.component.ts